import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const RctIcon: React.FC<ColorIconProps> = ({ size = "default", className }) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M7.89346 1.96762L1.95047 7.91061L7.89345 13.8536L7.89346 9.39635L12.2582 9.39636L12.2582 6.29824L7.89346 6.29824L7.89346 1.96762Z"
        fill="var(--cdl-chart-green-base)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.19576 1.23777C7.90058 1.1155 7.56081 1.18308 7.33489 1.40901L1.39191 7.35199C1.08342 7.66048 1.08342 8.16064 1.39191 8.46913L7.33489 14.4121C7.56081 14.638 7.90058 14.7056 8.19576 14.5834C8.49094 14.4611 8.6834 14.173 8.6834 13.8535L8.6834 10.1862L12.2582 10.1863C12.4677 10.1863 12.6686 10.103 12.8168 9.95488C12.9649 9.80674 13.0481 9.60582 13.0481 9.39631L13.0481 6.29819C13.0481 5.86192 12.6945 5.50825 12.2582 5.50825L8.6834 5.50825L8.6834 1.96758C8.6834 1.64808 8.49094 1.36004 8.19576 1.23777ZM7.10352 3.87466L7.10352 6.29819C7.10352 6.73446 7.45719 7.08813 7.89346 7.08813L11.4683 7.08813L11.4683 8.60637L7.89346 8.60637C7.68396 8.60637 7.48303 8.68959 7.33489 8.83773C7.18675 8.98588 7.10352 9.1868 7.10352 9.39631L7.10352 11.9465L3.06762 7.91056L7.10352 3.87466Z"
        fill="var(--cdl-chart-green-base)"
      />
      <path
        d="M12.2476 18.192L18.1906 12.249L18.1906 10.8645L12.2476 10.5876L7.88083 10.5876L7.88084 13.8614L12.2476 13.8614L12.2476 18.192Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.32226 10.0291C7.17411 10.1773 7.09089 10.3782 7.09089 10.5877L7.0909 13.8615C7.0909 14.2977 7.44457 14.6514 7.88084 14.6514L11.4577 14.6514L11.4577 18.1921C11.4577 18.5116 11.6501 18.7996 11.9453 18.9219C12.2405 19.0442 12.5802 18.9766 12.8062 18.7507L18.7491 12.8077C18.8973 12.6595 18.9805 12.4586 18.9805 12.2491L18.9805 10.8646C18.9805 10.4426 18.6489 10.0951 18.2273 10.0755L12.2843 9.79862C12.2721 9.79805 12.2598 9.79776 12.2476 9.79776L7.88083 9.79776C7.67132 9.79776 7.4704 9.88098 7.32226 10.0291ZM12.2292 11.3776L17.4006 11.6185L17.4006 11.9219L13.0375 16.285L13.0375 13.8615C13.0375 13.4252 12.6839 13.0715 12.2476 13.0715L8.67078 13.0715L8.67077 11.3776L12.2292 11.3776Z"
        fill="currentColor"
      />
      <path
        d="M12.2475 16.8043L18.1905 10.8613L12.2475 4.91833L12.2475 9.37557L7.88074 9.37557L7.88074 12.4737L12.2475 12.4737L12.2475 16.8043Z"
        fill="var(--cdl-bg-faint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9452 4.1885C11.65 4.31077 11.4575 4.59881 11.4575 4.91831L11.4575 8.5856L7.88073 8.5856C7.67122 8.5856 7.4703 8.66883 7.32215 8.81697C7.17401 8.96511 7.09079 9.16604 7.09079 9.37554L7.09079 12.4737C7.09079 12.9099 7.44445 13.2636 7.88072 13.2636L11.4575 13.2636L11.4575 16.8043C11.4575 17.1238 11.65 17.4118 11.9452 17.5341C12.2404 17.6563 12.5801 17.5888 12.8061 17.3628L18.749 11.4199C19.0575 11.1114 19.0575 10.6112 18.749 10.3027L12.8061 4.35974C12.5801 4.13381 12.2404 4.06623 11.9452 4.1885ZM13.0374 6.82539L17.0733 10.8613L13.0374 14.8972L13.0374 12.4737C13.0374 12.0374 12.6838 11.6837 12.2475 11.6837L8.67066 11.6837L8.67067 10.1655L12.2475 10.1655C12.457 10.1655 12.6579 10.0823 12.8061 9.93412C12.9542 9.78597 13.0374 9.58505 13.0374 9.37554L13.0374 6.82539Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RctIcon;
